<script lang="ts">
    import {SlideToggle} from '@skeletonlabs/skeleton';

    export let name: string;
    export let description: string;
    export let enabled: boolean;
    export let isAdminUser: boolean;
</script>

<div class="grid grid-cols-1 gap-5 lg:grid-cols-2">
    <div class="rounded-md border p-5">
        <div class="mb-5 text-lg font-bold text-primary-500">Feature Flag Details</div>
        <div class="grid grid-cols-4 gap-5">
            <div class="font-bold text-primary-500">Feature Flag Name</div>
            <div class="col-span-3">
                {name}
            </div>
            <div class="font-bold text-primary-500">Description</div>
            <div class="col-span-3">
                {#if isAdminUser}
                    <input class="input w-full" bind:value={description} />
                {:else}
                    <span>{description}</span>
                {/if}
            </div>
            <div class="font-bold text-primary-500">Enabled</div>
            <div class="col-span-3">
                <SlideToggle name="enabled" size="sm" bind:checked={enabled} active="bg-success-500" background="bg-secondary-600" />
            </div>
        </div>
    </div>
</div>